import React from 'react';
import { Link } from 'react-router-dom';
import {
  BOARD_ONE_PAGER,
  MANAGEMENT_COMPARISON,
  AI_MANAGEMENT_PILLARS,
  PMC_REPLACEMENT_CHECKLIST,
} from './hoaProductCatalog.js';
import { branding, isDemoBuild, SALES_EMAIL, DEMO_SITE_URL } from './siteConfig.js';

function HoaBoardOnePager({ isMobile }) {
  const salesEmail = isDemoBuild ? branding.contactEmail : SALES_EMAIL;
  const demoUrl = isDemoBuild ? branding.websiteUrl : DEMO_SITE_URL;

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className={`one-pager-page ${isMobile ? 'one-pager-page-mobile' : ''}`}>
      <div className="one-pager-toolbar no-print">
        <Link to="/for-communities" className="marketing-btn marketing-btn-ghost">
          ← Back to sales page
        </Link>
        <button type="button" className="marketing-btn marketing-btn-primary" onClick={handlePrint}>
          Print / Save as PDF
        </button>
      </div>

      <article className="one-pager-sheet">
        <header className="one-pager-header">
          <p className="one-pager-eyebrow">HOA Community Portal</p>
          <h1>{BOARD_ONE_PAGER.headline}</h1>
          <p className="one-pager-subhead">{BOARD_ONE_PAGER.subhead}</p>
        </header>

        <section className="one-pager-block">
          <h2>The problem</h2>
          <p>{BOARD_ONE_PAGER.problem}</p>
        </section>

        <section className="one-pager-block">
          <h2>The solution</h2>
          <p>{BOARD_ONE_PAGER.solution}</p>
        </section>

        <section className="one-pager-columns">
          <div>
            <h3>Keep</h3>
            <ul>
              {BOARD_ONE_PAGER.keepList.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </div>
          <div>
            <h3>Replace with portal + Nanny AI</h3>
            <ul>
              {BOARD_ONE_PAGER.replaceList.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </div>
        </section>

        <section className="one-pager-block">
          <h2>Cost snapshot (100 lots)</h2>
          <table className="one-pager-table">
            <thead>
              <tr>
                <th>Approach</th>
                <th>Monthly</th>
              </tr>
            </thead>
            <tbody>
              {MANAGEMENT_COMPARISON.map((row) => (
                <tr key={row.approach} className={row.highlight ? 'one-pager-row-highlight' : ''}>
                  <td>{row.approach}</td>
                  <td>${row.exampleMonthly.toLocaleString()}/mo</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="one-pager-block">
          <h2>Platform tiers (starting points)</h2>
          <table className="one-pager-table">
            <thead>
              <tr>
                <th>Tier</th>
                <th>From</th>
                <th>Best for</th>
              </tr>
            </thead>
            <tbody>
              {BOARD_ONE_PAGER.tiersSnapshot.map((tier) => (
                <tr key={tier.name}>
                  <td>{tier.name}</td>
                  <td>${tier.monthly}/mo</td>
                  <td>{tier.bestFor}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {BOARD_ONE_PAGER.optionalAddons?.length > 0 && (
            <div className="one-pager-optional-addons">
              <h3>Common add-ons (not in base tiers)</h3>
              <ul>
                {BOARD_ONE_PAGER.optionalAddons.map((addon) => (
                  <li key={addon.name}>
                    <strong>{addon.name}</strong> — {addon.estimate}. {addon.note}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </section>

        <section className="one-pager-block">
          <h2>How AI management works</h2>
          <ul className="one-pager-pillars">
            {AI_MANAGEMENT_PILLARS.map((pillar) => (
              <li key={pillar.id}>
                <strong>{pillar.title}</strong> — {pillar.description}
              </li>
            ))}
          </ul>
        </section>

        <section className="one-pager-block">
          <h2>PMC replacement timeline (summary)</h2>
          <ol className="one-pager-timeline">
            {PMC_REPLACEMENT_CHECKLIST.map((phase) => (
              <li key={phase.id}>
                <strong>{phase.phase}</strong> — {phase.summary}
              </li>
            ))}
          </ol>
        </section>

        <footer className="one-pager-footer">
          <p>
            <strong>Live demo:</strong> {demoUrl}
          </p>
          <p>
            <strong>Sales & scoping:</strong>{' '}
            <a href={`mailto:${salesEmail}`}>{salesEmail}</a>
          </p>
          <p className="one-pager-fine-print">
            Figures are planning estimates. Final quotes depend on lot count, integrations, and data migration.
            This platform supports self-managed boards; consult your attorney for contract termination and governance requirements.
          </p>
        </footer>
      </article>
    </div>
  );
}

export default HoaBoardOnePager;